import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { CPATTERN } from '../../shared/helpers/app.constants';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthLoginService } from '../auth.service';
import { UserService } from '../../shared/services';

@Component({
  selector: 'app-change-password-default',
  templateUrl: './change-password-default.component.html',
  styleUrls: ['./change-password-default.component.scss']
})
export class ChangePasswordDefaultComponent implements OnInit, OnDestroy {
  cvalidate = CPATTERN;
  loading: boolean = false;
  submitted: boolean = false;

  form: FormGroup;
  newPassword: AbstractControl;
  confirmPassword: AbstractControl;
  token: AbstractControl;
  constructor(private router: Router,
              private service: AuthLoginService,
              private formBuilder: FormBuilder,
              private userService: UserService,
              private ref: ChangeDetectorRef) {
    this.createForm();
  }

  createForm() {
    this.form = this.formBuilder.group({
      newPassword: new FormControl('', Validators.compose([
        Validators.required, Validators.minLength(8), Validators.maxLength(100),
        Validators.pattern(this.cvalidate.PASSWORD)])
      ),
      confirmPassword: new FormControl(''),
      token: new FormControl()
    }, {
      validator: this.checkIfMatchingPasswords('newPassword', 'confirmPassword')
    });
    this.newPassword = this.form.controls['newPassword'];
    this.confirmPassword = this.form.controls['confirmPassword'];
    this.token = this.form.controls['token'];
  }

  ngOnInit() {
    // check current user is changed password
    this.userService.getCurrentUser().toPromise().then(response => {
      if (response && response.result) {
        const user = response.result;
        if (user && user.isChangePassword) {
          this.router.navigate(['pages']);
        }
      } else {
        this.router.navigate(['auth/login']);
      }
    }).catch(err => this.router.navigate(['auth/login']));
  }

  ngOnDestroy() {
    this.ref.detach();
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({notEquivalent: true});
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.submitted = true;
      this.ref.detectChanges();
      const obj = {
        newPassword: this.newPassword.value,
      };
      this.service.changeDefaultPassword(obj, () => {
        this.loading = false;
        this.submitted = false;
        this.ref.detectChanges();
      })
        .subscribe(
          (response) => {
            this.router.navigate(['pages', 'dashboard']);
          });
    }
  }
}
